<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    松岗公园站<br>
站点介绍<br>
松岗公园站位于深圳市宝安区沙江东路与东风路交叉路口，车站主体呈东西走向，东接薯田埔站，西接溪头站。 车站色彩基调以白色为主，为地下二层车站，地下二层为站台层，地下一层为站厅层，站台形式为岛式站台。车站共设4个出入口，临近松岗公园，周边以住宅、生态绿地为主。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:24	23:03	6号线	3分24秒	6分20秒<br>
松岗	06:22	00:07	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:23	23:03	6号线	4分45秒	6分钟<br>
松岗	06:22	00:07	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:23	00:03	6号线	4分45秒	6分钟<br>
松岗	06:22	01:07	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
沙江东路北侧（东）、集信名城<br><br>
B出入口:<br>
沙江东路北侧（西）、松岗公园<br><br>
C出入口:<br>
沙江东路南侧（西）、东风公园<br><br>
D出入口:<br>
沙江东路南侧（东）、东风路、松岗卫生监督所、个体劳动者协会第十分会、宝安市场监督管理局沙溪所、宝安食品药品监督管理局沙溪所<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 松岗公园地铁站公交站<br>
B980,M332,M260,B911,M286,M178,M552,莞312,M255<br><br>
A出入口:<br>
公交站名： 松岗教堂站<br>
B980,B911,M255,M178,M552,M260,M286<br><br>
B出入口:<br>
公交站名： 集信名城站<br>
B980,M332,M260,B911,M255,M178,M552,M286<br><br>
C出入口:<br>
公交站名： 集信名城站<br>
B980,M332,M260,B981,B911,M286,M178,M552,M255<br><br>
D出入口:<br>
公交站名： 松岗公园地铁站公交站<br>
B980,M332,M260,B981,B911,M178,M286,M255,M552,莞312<br><br>
D出入口:<br>
公交站名： 松岗教堂站<br>
B980,M552<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>